import { CustomNode } from '../../../types';
import { modifyChannelIcon } from '../../../icons';

const DEFAULT_ICON = modifyChannelIcon;

export const modifyChannelConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
